import React from "react";
import Reveal from "./Reveal";

const PARTNERS = [
  { name: "Škoda", sub: "Auto" },
  { name: "Toyota", sub: "" },
  { name: "Volvo", sub: "Průhonice" },
  { name: "UniCredit", sub: "Leasing" },
  { name: "Drivalia", sub: "" },
  { name: "AAAauto", sub: "" },
  { name: "Knokar", sub: "" },
];

export const Partners = () => {
  return (
    <section data-testid="partners-section" className="relative py-12 sm:py-16 md:py-20 border-y border-white/5 bg-black">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <Reveal className="text-center mb-7 sm:mb-10">
          <div className="text-[10px] tracking-[0.35em] sm:tracking-[0.4em] uppercase text-[#D4AF37]">
            Připravujeme vozidla pro
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-4 sm:gap-x-10 sm:gap-y-6 md:gap-x-14">
            {PARTNERS.map((p) => (
              <div
                key={p.name}
                data-testid={`partner-${p.name.toLowerCase()}`}
                className="flex items-baseline gap-2 grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all duration-500"
              >
                <span className="font-display text-xl sm:text-2xl md:text-3xl text-zinc-200 tracking-wide">
                  {p.name}
                </span>
                {p.sub && (
                  <span className="text-[9px] sm:text-[10px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-zinc-500">
                    {p.sub}
                  </span>
                )}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={200} className="mt-7 sm:mt-10 text-center">
          <p className="text-xs text-zinc-500 max-w-2xl mx-auto leading-relaxed">
            Dlouholetí partneři — autorizovaní dealeři, leasingové společnosti a provozovatelé flotil
            nám svěřují vozy k finální přípravě pro klienty.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Partners;
